import { makeStyles } from "@material-ui/core/styles";
import {
  drawerWidth,
  drawerWithSmallSize,
} from "../../../shared/components/new-participant-layout/new-participant-layout.styles";

export const learningStyles = makeStyles((theme) => ({
  backgroundImage: {
    position: "absolute",
    top: "0px",
    right: "-1px",
    [theme.breakpoints.only("xs")]: {
      height: "243px",
      top: "130px",
      left: "0px",
      width: "100%",
    },
    [theme.breakpoints.only("sm")]: {
      height: "363px",
      top: "60px",
      left: "0px",
      width: "100%",
    },
    [theme.breakpoints.only("md")]: {
      top: "60px",
      left: drawerWithSmallSize,
      width: `calc(100% - ${drawerWithSmallSize}px)`,
      height: "400px",
    },
    [theme.breakpoints.up("lg")]: {
      top: "60px",
      left: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      height: "600px",
    },
  },
  paperContainer: {
    position: "relative",
    width: "100%",
    padding: "2px 20px 0px 20px",
    marginBottom: " 30px",
    [theme.breakpoints.only("xs")]: {
      marginTop: "20%",
    },
    [theme.breakpoints.only("sm")]: {
      marginTop: "18%",
    },
    [theme.breakpoints.only("md")]: {
      marginTop: "30%",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "27%",
    },
  },
  divider: {
    border: "1px solid #E6E6E6",
  },
  clockIcon: {
    marginRight: "5px",
  },
  contentDetails: {
    padding: "30px 0px 30px 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      flexWrap: "wrap",
    },
  },
  contentDetail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 10px 0px 10px",
    borderRight: "1px solid #45547C",
    color: "#45547C",
    fontFamily: "Lato",
    fontWeight: 400,

    "&:last-child": {
      borderRight: "none",
    },
    [theme.breakpoints.only("xs")]: {
      fontSize: theme.typography.pxToRem(11),
      padding: "0px 5px 0px 5px",
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: theme.typography.pxToRem(13),
      padding: "0px 5px 0px 5px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: theme.typography.pxToRem(14),
      padding: "0px 5px 0px 5px",
    },
  },
  recommendedContainer: {
    marginBottom: "200px",
  },
  recommendedTitle: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(24),
    marginBottom: "18px",
  },
}));
